import { User } from '@/store/models';

const APP__ID_TOKEN_KEY = 'APP__ID_TOKEN_KEY';
const APP__USER = 'APP__USER';
const APP__LANGUAGE = 'APP__LANGUAGE';

class JwtService {
  public getToken() {
    return window.localStorage.getItem(APP__ID_TOKEN_KEY);
  }

  public async saveToken(token: string) {
    await Promise.all([window.localStorage.setItem(APP__ID_TOKEN_KEY, token)]);
  }

  public async destroyJWT() {
    await Promise.all([
      window.localStorage.removeItem(APP__ID_TOKEN_KEY),
      window.localStorage.removeItem(APP__USER)
    ]);
  }

  public saveUser(user: User) {
    window.localStorage.setItem(APP__USER, JSON.stringify(user));
  }

  public async getUser(): Promise<User> {
    return await JSON.parse(window.localStorage.getItem(APP__USER) || '{}');
  }

  public saveLanguage(language: string) {
    return window.localStorage.setItem(APP__LANGUAGE, language);
  }

  public getLanguage() {
    return (
      window.localStorage.getItem(APP__LANGUAGE) ||
      process.env.VUE_APP_I18N_LOCALE ||
      'en'
    );
  }
}

const jwtService = new JwtService();
export default jwtService;
